import OperatingRoom from '../../../dPbloc/vue/Classes/OperatingRoom'
import Room from '../../../dPbloc/vue/Classes/ClvrRoom'
import { Nullable } from '@internal-libraries/kheops-ui-lib'
import { ClvrScreenControlDto } from '../Types/ClvrScreenControlDto'
import { ScreenControlData } from '../Types/ScreenControlData'
import { ScreenControlTemplateData } from '../Types/ScreenControlTemplateData'

export default class ClvrScreenControl {
    public id: Nullable<number> = null
    public name = ''
    public templateId = 0
    public operatingRoomId: Nullable<number> = null
    public isActive = true
    public groupId = 0
    public creationDate?: Date
    public updateDate?: Date

    public template?: ScreenControlTemplateData
    public operatingRoom?: OperatingRoom
    public rooms: Room[] = []

    public roomNames?: string

    public static SCREEN_CONTROL_URL = 'index.php?m=bloc&a=display_screen_control'

    public constructor(data?: ScreenControlData) {
        if (data) {
            Object.assign(this, data)
        }
        this.createStringRoomList()
    }

    public createStringRoomList(): void {
        if (this.rooms) {
            this.roomNames = this.rooms.map(room => room.name).join(', ')
        }
    }

    public get fullName(): string {
        return `${this.name} - ${this.operatingRoom?.name}`
    }

    public static getScreenControlUrl(screenControlId?: Nullable<number>, date: Nullable<string> = null): string {
        const prefix = `${this.SCREEN_CONTROL_URL}&dialog=1`
        if (screenControlId) {
            return `${prefix}&id=${screenControlId}${date ? '&date=' + date : ''}`
        }
        return prefix
    }

    public toDto(): ClvrScreenControlDto {
        return {
            id: this.id,
            name: this.name,
            sc_template_id: this.templateId,
            bloc_operatoire_id: this.operatingRoomId,
            is_active: this.isActive,
            group_id: this.groupId,
            creation_date: this.creationDate,
            update_date: this.updateDate,
            _ref_salles: this.rooms.map(room => room.toDto()),
        }
    }
}
